<template>
<div>
    <Cbarra>
        <template slot="slotTitle">Noticias</template>
        <template slot="slotRoute">
            <router-link :to="{name:'index'}">Inicio</router-link> / <router-link :to="{name:'inoticia'}">Noticias</router-link>
        </template>
    </Cbarra>

    <div class="container">
        <div class="bg-principal-02">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <h1 class="text-center mb-3 color_Azul">
                        <b>Noticias y Convocatorias</b>
                    </h1>
                    <hr class="titulo_hr01 mb-5">
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                    <form role="form" class="form-inline">
                        <input v-model="oFiltro.valueSearch" type="text" class="form-control mr-2 mb-2" placeholder="Buscar noticia">
                        <button type="button" @click="get_noticias()" class="btn btn-primary mb-2">Buscar</button>
                    </form>
                    <hr>
                </div>
            </div>
            <div class="row">
                <template v-for="(item, index) in listaNoticias" >
                    <noticias :value="item" :rutathumbnail="RutaFileNoticiathumbnail" :rutafile="RutaFileNoticia" :key="index"></noticias>
                </template>
            </div>

            <div class="row">
                <div class="col-12">
                    <b-pagination
                    class="pagination justify-content-end"
                    v-model="currentPage"
                    :total-rows="oFiltro.totalItems"
                    :per-page="oFiltro.pageSize"
                    aria-controls="my-table"
                    @input="get_noticias"
                    ></b-pagination>
                </div>
            </div>  
        </div>
    </div>
</div>
</template>

<script>
import noticias from '../modales/noticias.vue'

export default {
    components:{noticias
    },
    name:'noticia',
    props:["ptxtSearch"],
    data() {
        return {
            oFiltro:{//objeto para filtros
                placeHSearch:'Titulo',
                valueSearch:'',
                entrada:9,
                pag:1,
                totalItems:0,
                pageSize:0,
            },
            listaNoticias:[],
            RutaFileNoticia:'',
            RutaFileNoticiathumbnail:'',
            currentPage:1,
        }
    },
    methods: {
        async get_noticias()
        {
            await this.$http.get(
                'inicio/noticias/',
                {
                    params:{TxtBusqueda:this.oFiltro.valueSearch, RegEstatus:'A',Seccion:'Inicio',Entrada:this.oFiltro.entrada,pag:this.oFiltro.pag}
                }
            ).then( (res) => {
                this.listaNoticias = res.data.noticia;
                this.oFiltro.pag = res.data.pagination.CurrentPage;
                this.oFiltro.totalItems = res.data.pagination.TotalItems;
                this.oFiltro.pageSize = res.data.pagination.PageSize;
                this.RutaFileNoticia = res.data.RutaFile;
                this.RutaFileNoticiathumbnail=res.data.RutaFilethumbnail;
                
            });
        }
    },
    created() {
        window.scrollTo(0, 0);
    },
    mounted() {
        
        if(this.ptxtSearch!=undefined){
            this.oFiltro.valueSearch=this.ptxtSearch;
        }

        this.get_noticias();
    },
    watch: { currentPage(newPage) { 
            this.oFiltro.pag = newPage;
            this.get_noticias();
        }
    },
}
</script>